export default class Param {
    constructor(){

        this.breakpoint = 750;
        this.displayType = ( window.innerWidth>this.breakpoint)?"pc":"sp";
        this.scrollType = "";

        this.conf = {
            keycolor : "#03092d"
        }

        this.webgl = {
            panel : {
                shader : {
                    vert : require('../shader/line.vert'),
                    frag : require('../shader/line.frag')
                }
            }
        }

        this.status = {

        }
        this.youtube = {
            domID : "p-business-rental-movie-view-yt",
            id    : "PMsmv8nqnLg"
        }


    }
}
